module.exports = __webpack_public_path__ + "static/media/116.01787fa1.png";